import { motion } from "framer-motion";
import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";

const AV_BY_LINK = "https://av.by/company/transport/3049756";

const navLinks = [
  { href: "#services", label: "Услуги" },
  { href: "#advantages", label: "Преимущества" },
  { href: "#examples", label: "Примеры" },
  { href: "#calculator", label: "Калькулятор" },
  { href: "#contact", label: "Контакты" },
];

export default function Footer() {
  const scrollToSection = (href) => {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer 
      className="bg-[#050505] border-t border-white/10 py-16"
      data-testid="footer"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 border border-white/30 flex items-center justify-center">
                <span className="text-white font-bold text-xs tracking-wider">SBE</span>
              </div>
              <span className="text-white text-lg font-light">
                SBE.by
              </span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              Импорт автомобилей с обслуживанием премиум-класса из Китая, Кореи и США в Республику Беларусь
            </p>
            <p className="text-white/30 text-xs">
              УНП: 192870066
            </p>
          </div>

          {/* Navigation */}
          <div>
            <p className="text-white/40 text-xs uppercase tracking-widest mb-6">
              Навигация
            </p>
            <nav className="space-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-white/60 hover:text-white text-sm transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white/40 text-xs uppercase tracking-widest mb-6">
              Контакты
            </p>
            <div className="space-y-4">
              <a 
                href="tel:+375293376600" 
                className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors duration-300"
              >
                <Phone className="w-4 h-4" strokeWidth={1} />
                +375 29 337-66-00
              </a>
              <a 
                href="tel:+375333376600" 
                className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors duration-300"
              >
                <Phone className="w-4 h-4" strokeWidth={1} />
                +375 33 337-66-00
              </a>
              <div className="flex items-center gap-3 text-white/60 text-sm">
                <MapPin className="w-4 h-4" strokeWidth={1} />
                г. Минск, Беларусь
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <p className="text-white/40 text-xs uppercase tracking-widest mb-6">
              Ссылки
            </p>
            <div className="space-y-4">
              <a 
                href={AV_BY_LINK}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors duration-300"
                data-testid="footer-avby-link"
              >
                <ExternalLink className="w-4 h-4" strokeWidth={1} />
                Авто на av.by
              </a>
              <a 
                href="https://t.me/+375333376600" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-white/60 hover:text-white text-sm transition-colors duration-300"
                data-testid="footer-telegram-link"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
                </svg>
                Telegram
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/30 text-xs">
            © {new Date().getFullYear()} ООО «СертБелИнжиниринг». Все права защищены.
          </p>
          <p className="text-white/20 text-xs">
            Импорт авто из Китая, Кореи, США
          </p>
        </div>
      </div>
    </footer>
  );
}
